import { Text } from '@components';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import InvestmentFooter from '../InvestmentFooter/InvestmentFooter';
import {
  Container,
  ContentContainer,
  Root,
} from './SubscriptionUnavailable.styles';
import { SubscriptionUnavailableType } from './SubscriptionUnavailable.types';
import { dataByType } from './SubscriptionUnavailable.utils';
import { ButtonProps } from '@components/Button/Button';

const SubscriptionUnavailable: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { productId } = useParams();
  const { state } = useLocation();
  const nextButtonProps: ButtonProps = state.nextButtonProps;
  const type = state?.type as SubscriptionUnavailableType;
  const { image, title, description } = dataByType[type];

  return (
    <Root>
      <Container>
        <ContentContainer>
          <img alt='alert logo' src={image} style={{ height: 128 }} />
          <Text variant='h4' fontWeight='fontWeightSemiBold'>
            {title}
          </Text>
          <Text variant='h5' fontWeight='fontWeightSemiBold'>
            {description}
          </Text>
        </ContentContainer>
      </Container>

      <InvestmentFooter
        secondaryButton={
          state?.previousPathName
            ? {
                title: intl.formatMessage({
                  id: 'misc.previous',
                }),
                onClick: () =>
                  navigate(
                    `/investment-subscription/${productId}/${state.previousPathName}`,
                    {
                      state: {
                        progress: state.progress,
                      },
                      replace: true,
                    }
                  ),
              }
            : undefined
        }
        primaryButton={{
          title: intl.formatMessage({
            id: 'misc.next',
          }),
          disabled: true,
          ...nextButtonProps,
        }}
      />
    </Root>
  );
};

export default SubscriptionUnavailable;
